import { render, staticRenderFns } from "./Dids.vue?vue&type=template&id=01ba1832&"
import script from "./Dids.vue?vue&type=script&lang=js&"
export * from "./Dids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports